//#region import libraries
import React, { useEffect, useState } from 'react';

// bootstrap
import { Row, Col, Form, Button, Modal, Container } from 'react-bootstrap';

// styling
import { Colors } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';

// custom components
import { CustomSpinner, ErrorMessage } from '_atoms';
import { CountrySelector, AirportListSelector, HoursRangeSelector } from '_molecules';

//PHONE-NUMBER
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

// tremor
import { Flex } from '@tremor/react';
import { uploadImage, selectPostedImage, selectImageStatus, reset } from '_redux/slices/prm-club/rewards';

import { createRetailer, selectAddingRetailerError, selectAddingRetailerStatus, selectOneRetailer, reset as resetRetailerStatus } from '_redux/slices/marketplace/retailer';
import { AiOutlineCloudUpload } from 'react-icons/ai';
//#endregion

const RetailerForm = (props) => {
    //#region redux
    // redux
    const dispatch = useDispatch();

    const userDb = useSelector(selectUserDb);

    // retailer redux
    const selectedRetailer = useSelector(selectOneRetailer)
    const addingRetailerError = useSelector(selectAddingRetailerError);
    const addingRetailerStatus = useSelector(selectAddingRetailerStatus);
    // image redux
    const imageStatus = useSelector(selectImageStatus);
    const uploadedImage = useSelector(selectPostedImage);
    //#endregion

    //#region local state
    // local states
    const [errors, setErrors] = useState({});
    const [enableAdding, setEnableAdding] = useState(false); // this state to prevent any auto adding after open the page, first time
    const [imageLoading, setImageLoading] = useState(false);

    const [showDeliveryModal, setShowDeliveryModal] = useState(false)
    const [showAirportModal, setShowAirportModal] = useState(false)
    const [showHoursModel, setShowHoursModel] = useState(false)
    //image states
    const [imagePreview, setImagePreview] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    // border colors
    const [nameBorder, setNameBorder] = useState('grey');
    const [linkBorder, setLinkBorder] = useState('grey');
    const [descriptionBorder, setDescriptionBorder] = useState('grey');
    const [phoneNumberBorder, setPhoneNumberBorder] = useState('grey');
    const [addressLine1Border, setAdrressLin1Border] = useState('grey');
    const [addressLine2Border, setAdrressLin2Border] = useState('grey');
    const [notesBorder, setNotesBorder] = useState('grey');
    const [cityBorder, setCityBorder] = useState('grey');
    const [countryBorder, setCountryBorder] = useState('grey');
    const [postalCodeBorder, setPostalCodeBorder] = useState('grey');
    const [countriesBorder, setCountriesBorder] = useState('grey');
    const [iataListBorder, setIataListBorder] = useState('grey');
    const [openingHoursBorder, setOpeningHoursBorder] = useState('grey');
    const [imageBorder, setImageBorder] = useState('grey');
    //form state    
    const [retailerFieldsValues, setRetailerFieldsValues] = useState({
        retailerName: selectedRetailer?.retailerName || '',
        websiteLink: selectedRetailer?.websiteLink || '',
        phoneNumber: selectedRetailer?.phoneNumber || '',
        description: selectedRetailer?.description || '',
        addressLine1: selectedRetailer?.addressLine1 || '',
        addressLine2: selectedRetailer?.addressLine2 || '',
        city: selectedRetailer?.city || '',
        country: selectedRetailer?.country || '',
        postalCode: selectedRetailer?.postalCode || '',
        countries: selectedRetailer?.countries || '',
        iataList: selectedRetailer?.iataList || '',
        openingHours: selectedRetailer?.openingHours || {},
        collectionNotes: selectedRetailer?.collectionNotes || '',
        collectAvailability: selectedRetailer?.collectAvailability || true,
        deliverAvailability: selectedRetailer?.deliverAvailability || true,
    })
    //#endregion

    //#region useEffect
    useEffect(() => {
        dispatch(resetRetailerStatus())
        dispatch(reset())
    }, [])

    useEffect(() => {
        if (addingRetailerStatus === 'succeeded') {
            setRetailerFieldsValues({
                retailerName: '',
                websiteLink: '',
                phoneNumber: '',
                description: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                country: '',
                countries: '',
                postalCode: '',
                iataList: '',
                collectionNotes: ''
            })
            props.submitted()
        }
    }, [addingRetailerStatus])

    // image upload listener
    useEffect(() => {
        if (imageStatus == 'loading') {
            // image is being uploaded
            setImageLoading(true);
        }

        //if image is being uploaded, then submit form
        if (imageStatus === "succeeded" && enableAdding) {
            setImageLoading(false)
            handleSubmit()
        }
    }, [imageStatus]);
    //#endregion

    //#region functions
    const manageAvailability = () => {
        setShowDeliveryModal(true)
    }
    //change fields input, update state, call validation function
    const handleChangeInput = (e) => {
        e.preventDefault();
        let { name, value } = e.target;
        setRetailerFieldsValues((prevState) => {
            const updatedFields = { ...prevState, [name]: value };
            // Call validateFields with updated state
            handleValidation(updatedFields);

            return updatedFields;
        });
    }

    const handleChangePhone = (value) => {
        setRetailerFieldsValues((prevState) => {
            const updatedFields = { ...prevState, phoneNumber: value };
            // Call validateFields with updated state
            handleValidation(updatedFields);

            return updatedFields;
        });
    }
    // handle checkbox changes for deliver/collect availability
    const handleChecking = (event) => {
        const { checked, name } = event.target;
        setRetailerFieldsValues((prevState) => {
            const updatedFields = { ...prevState, [name]: checked };

            return updatedFields;
        });
    }
    //validate the fields
    const handleValidation = (fields) => {
        const tempErrors = {},
            { retailerName, websiteLink, phoneNumber, description, addressLine1, city, collectionNotes, country, countries, openingHours, postalCode, iataList } = fields;

        const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // check retailer name
        if (retailerName.length < 3) {
            tempErrors.retailerName = "Please enter a valid Name"
            setNameBorder('red')
        } else { setNameBorder('green') }
        // check website link
        if (websiteLink.length == 0) {
            tempErrors.websiteLink = "Please enter a valid website link"
            setLinkBorder('red')
        } else { setLinkBorder('green') }
        if (description.length == 0) {
            tempErrors.description = "Please enter a valid description"
            setDescriptionBorder('red')
        } else { setDescriptionBorder('green') }
        //check phone number using validator from package
        if (phoneNumber) {
            if (!isValidPhoneNumber(phoneNumber)) {
                tempErrors.phone = "Please enter valid number";
                setPhoneNumberBorder("red")
            } else setPhoneNumberBorder("green")
        } else {
            tempErrors.phone = "Please enter valid number";
            setPhoneNumberBorder("red")
        }
        // check address details
        if (addressLine1.length == 0) {
            tempErrors.addressLine1 = "Please enter a valid address for Line 1"
            setAdrressLin1Border("red")
        } else {
            setAdrressLin1Border("green")
        }
        // check city
        if (city.length == 0) {
            tempErrors.city = "please enter a valid city";
            setCityBorder("red")
        } else { setCityBorder("green") }
        // check country
        if (country.length == 0) {
            tempErrors.country = "please enter a valid country";
            setCountryBorder("red")
        } else { setCountryBorder("green") }
        // check postal code
        if (postalCode.length == 0) {
            tempErrors.postalCode = "please enter a valid postal code";
            setPostalCodeBorder("red")
        } else setPostalCodeBorder("green")
        // check collection Notes 
        if (collectionNotes.length == 0) {
            tempErrors.collectionNotes = "please enter a valid collection notes";
            setNotesBorder("red")
        } else setNotesBorder("green")
        // check Collection airport
        if (iataList.length == 0) {
            tempErrors.iataList = "Please select at least one airport to deliver to";
            setIataListBorder("red")
        } else setIataListBorder("green")

        // check countries
        if (countries.length == 0) {
            tempErrors.countries = "Please select at least one country to deliver to"
            setCountriesBorder("red")
        } else { setCountriesBorder("green") }
        // check Opening hours
        if (!Object.keys(openingHours).length) {
            tempErrors.hours = "Please specific hours availability "
            setOpeningHoursBorder("red")
        } else { setOpeningHoursBorder("green") }
        //check image if it's uploaded
        if (!selectedImage) {
            tempErrors.image = 'Image required';
            setImageBorder("red")
        } else { setImageBorder("green") }

        setErrors(tempErrors)
        return tempErrors
    }
    // submit fields of retailer after checking its validation
    const handleSubmit = () => {
        const result = handleValidation(retailerFieldsValues);
        if (!Object.keys(errors).length && !Object.keys(result).length) {
            // post retailer information
            const databaseObject = {
                id: retailerFieldsValues.retailerName?.toLowerCase().replace(/\s+/g, "-"),
                userId: userDb._id,
                imageUrl: uploadedImage,
                retailerName: retailerFieldsValues.retailerName,
                websiteLink: retailerFieldsValues.websiteLink,
                description: retailerFieldsValues.description,
                phoneNumber: retailerFieldsValues.phoneNumber,
                collectionNotes: retailerFieldsValues.collectionNotes,
                collectAvailability: retailerFieldsValues.collectAvailability,
                deliverAvailability: retailerFieldsValues.deliverAvailability,
                iataList: retailerFieldsValues.iataList,
                countries: retailerFieldsValues.countries,
                openingHours: retailerFieldsValues.openingHours,
                address: {
                    addressLine1: retailerFieldsValues.addressLine1,
                    addressLine2: retailerFieldsValues.addressLine2,
                    postalCode: retailerFieldsValues.postalCode,
                    city: retailerFieldsValues.city,
                    country: retailerFieldsValues.country,
                }
            }
            console.log('create retailer...', databaseObject);
            dispatch(createRetailer(databaseObject));
        }
    }

    //On clicking create; upload image then  submit the trailer with image
    const handlePreSubmit = () => {
        const valideForm = handleValidation(retailerFieldsValues);
        if (!Object.keys(valideForm).length) {
            dispatch(uploadImage(selectedImage))
            setEnableAdding(true)
        }
    }

    //update countries list state with selected value, validate values
    const handleSelectCountries = (countries) => {
        setCountriesBorder("green"),
            setRetailerFieldsValues((prevState) => {
                const updatedFields = { ...prevState, countries: countries };
                // Call validateFields with updated state
                handleValidation(updatedFields);

                return updatedFields;
            });
        setShowDeliveryModal(false)
    }

    //update iata list state with selected value, validate values
    const handleSelectIataList = (iataList) => {
        setIataListBorder("green"),
            setRetailerFieldsValues((prevState) => {
                const updatedFields = { ...prevState, iataList: iataList };
                // Call validateFields with updated state
                handleValidation(updatedFields);

                return updatedFields;
            });
        setShowAirportModal(false)
    }

    //update opening hours state with selected value, validate values
    const handleOpeningHours = (openingHours) => {

        const openHourValue = { openHour: openingHours.openHour, closeHour: openingHours.closeHour }
        setRetailerFieldsValues((prevState) => {
            const updatedFields = { ...prevState, openingHours: openHourValue };
            // Call validateFields with updated state
            handleValidation(updatedFields);

            return updatedFields;
        });
        setShowHoursModel(false)
    }

    //save image in state, remove image error
    const handleImageSelect = (image) => {
        setSelectedImage(image);
        setImagePreview(URL.createObjectURL(image)); // Generate a preview
        if (errors.image) {
            delete errors.image;
            setImageBorder('green')
        }
    };
    //#endregion

    return (
        <>
            <Row>
                <Col md={9}></Col>

                <Container className='mt-3'>
                    <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />
                </Container>

                <Container>
                    {addingRetailerError && <ErrorMessage title={"Error Creating Reatiler"}>{addingRetailerError}</ErrorMessage>}
                </Container>

                {/* Retailer Name, Website URL ,phone number and description */}
                <Form.Group className='mt-4'>
                    <Row>
                        <Col>
                            <Form.Label style={{ color: nameBorder }}>Retailer Name</Form.Label>
                            <Form.Control onChange={handleChangeInput} value={retailerFieldsValues.retailerName} name="retailerName" type="name" placeholder="Enter the retailer's Name" style={{ borderColor: nameBorder }} />
                            {errors.retailerName && (<p className="text-danger">{errors.retailerName}</p>)}
                        </Col>
                        <Col>
                            <Form.Label style={{ color: linkBorder }}>Website URL</Form.Label>
                            <Form.Control onChange={handleChangeInput} value={retailerFieldsValues.websiteLink} name="websiteLink" type="name" placeholder="Enter the link to the retailer website" style={{ borderColor: linkBorder }} />
                            {errors.websiteLink && (<p className="text-danger">{errors.websiteLink}</p>)}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <Form.Label className="mt-3" style={{ color: descriptionBorder }}>Description</Form.Label>
                            <Form.Control as="textarea" style={{ height: '100px', borderColor: descriptionBorder }} type="text" placeholder="Type a little description about you!" onChange={handleChangeInput} name="description" value={retailerFieldsValues.description} />
                            {errors.description && (<p className="text-danger">{errors.description}</p>)}
                        </Col>
                        <Col xs={6}>
                            <Form.Label className="mt-3" style={{ color: phoneNumberBorder }}>Phone</Form.Label>
                            <PhoneInput
                                placeholder="Enter phone number"
                                value={retailerFieldsValues.phoneNumber}
                                onChange={handleChangePhone}
                                defaultCountry="IE"
                            />
                            {errors.phone && (<p className="text-danger">{errors.phone}</p>)}
                        </Col>
                    </Row>
                </Form.Group>

                {/* Collection Address ,Airports, Countries*/}
                <Row>
                    <Form.Label className='mt-4' style={{ color: Colors.PRM_LIGHT_BLUE }}>Address Information</Form.Label>
                    <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />
                    <Form.Group className='mt-3'>
                        <Row>
                            <Col>
                                {/* Address Line 1 */}
                                <Form.Label style={{ color: addressLine1Border }}>Address Line 1</Form.Label>
                                <Form.Control onChange={handleChangeInput} name='addressLine1' type="name" placeholder="Address Line 1" value={retailerFieldsValues.addressLine1.length ? retailerFieldsValues.addressLine1 : null} style={{ borderColor: addressLine1Border }} />
                                {errors.addressLine1 && (<p className="text-danger">{errors.addressLine1}</p>)}
                                {/* Address Line 2 */}
                                <Form.Label className='mt-3' style={{ color: addressLine2Border }}>{"Address Line 2 (Optional)"}</Form.Label>
                                <Form.Control onChange={handleChangeInput} name="addressLine2" type="name" placeholder="Address Line 2" value={retailerFieldsValues.addressLine2.length ? retailerFieldsValues.addressLine2 : null} style={{ borderColor: addressLine2Border }} />
                                {errors.addressLine2 && (<p className="text-danger">{errors.addressLine2}</p>)}
                                {/* Post Code */}
                                <Form.Label className='mt-3' style={{ color: postalCodeBorder }}>Postal Code</Form.Label>
                                <Form.Control onChange={handleChangeInput} name="postalCode" type="name" placeholder="Postal Code" value={retailerFieldsValues.postalCode ? retailerFieldsValues.postalCode : null} style={{ borderColor: postalCodeBorder }} />
                                {errors.postalCode && (<p className="text-danger">{errors.postalCode}</p>)}
                            </Col>
                            <Col>
                                {/* City */}
                                <Form.Label style={{ color: cityBorder }}>City</Form.Label>
                                <Form.Control onChange={handleChangeInput} name="city" type="name" placeholder="City" value={retailerFieldsValues.city ? retailerFieldsValues.city : null} style={{ borderColor: cityBorder }} />
                                {errors.city && (<p className="text-danger">{errors.city}</p>)}
                                {/* Country */}
                                <Form.Label className='mt-3' style={{ color: countryBorder }}>Country</Form.Label>
                                <Form.Control onChange={handleChangeInput} name="country" type="name" placeholder="Country" value={retailerFieldsValues.country ? retailerFieldsValues.country : null} style={{ borderColor: countryBorder }} />
                                {errors.country && (<p className="text-danger">{errors.country}</p>)}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Form.Label className="mt-3" style={{ color: notesBorder }}>Collection Notes</Form.Label>
                                <Form.Control as="textarea" style={{ height: '100px', borderColor: notesBorder }} type="text" placeholder="Type any instructions you would like to be forwarded to customers" onChange={handleChangeInput} name="collectionNotes" value={retailerFieldsValues.collectionNotes} />
                                {errors.collectionNotes && (<p className="text-danger">{errors.collectionNotes}</p>)}
                            </Col>
                        </Row>
                    </Form.Group>

                    <Row className='mt-4'>
                        <Form.Label className='mt-4' style={{ color: Colors.PRM_LIGHT_BLUE }}>Availability Information</Form.Label>
                        <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />
                        {/*Collection availability checkbox*/}
                        <Row className='mb-4'>
                            <Col md={4}>
                                <Flex >
                                    <Form.Label>Collect is available</Form.Label>
                                    <Form.Check
                                        type="checkbox"
                                        name='collectAvailability'
                                        value={retailerFieldsValues.collectAvailability}
                                        defaultChecked={true}
                                        onChange={handleChecking}
                                    />
                                </Flex>
                            </Col>
                            <Col md={4}>
                                <Flex >
                                    <Form.Label>Deliver is available</Form.Label>
                                    <Form.Check
                                        type="checkbox"
                                        name='deliverAvailability'
                                        value={retailerFieldsValues.deliverAvailability}
                                        defaultChecked={true}
                                        onChange={handleChecking}
                                    />
                                </Flex>
                            </Col>
                        </Row>
                        {/* Airports selector*/}
                        <Col md={4}>
                            <Form.Label style={{ color: iataListBorder }}>Collection Airport</Form.Label>
                            <p style={{ fontSize: 16, fontWeight: '600', opacity: 0.6 }}>Choose which airports your product can be collected within</p>
                            <Container>
                                <Button onClick={() => { setShowAirportModal(true) }} style={{ width: 300 }}>Manage Collection Airports</Button>
                            </Container>
                            {errors.iataList && (<p className="text-danger">{errors.iataList}</p>)}

                        </Col>
                        {/* Delivery Countries */}
                        <Col md={4}>
                            <Form.Label style={{ color: countriesBorder }}>Delivery Availability</Form.Label>
                            <p style={{ fontSize: 16, fontWeight: '400' }}>Please choose which countries your product is available for delivery within</p>
                            {retailerFieldsValues.countries && retailerFieldsValues.countries.length > 0 && <p>Available in {retailerFieldsValues.countries && retailerFieldsValues.countries.length} countries</p>}
                            <Container>
                                <Button onClick={manageAvailability} style={{ width: 200 }}>Manage Availability</Button>
                            </Container>
                            {errors.countries && (<p className="text-danger">{errors.countries}</p>)}
                        </Col>
                        {/* Opening hours */}
                        <Col md={4}>
                            <Form.Label style={{ color: openingHoursBorder }}>Opening hours </Form.Label>
                            <p style={{ fontSize: 16, fontWeight: '400' }}>Please choose hours you are available  to receive your products orders  </p>
                            {retailerFieldsValues.openingHours && retailerFieldsValues.openingHours.openHour && retailerFieldsValues.openingHours.closeHour && <p>Available from {retailerFieldsValues.openingHours.openHour} to {retailerFieldsValues.openingHours.closeHour} </p>}
                            <Container>
                                <Button onClick={() => setShowHoursModel(true)} style={{ width: 200 }}>Manage Availability</Button>
                            </Container>
                            {errors.hours && (<p className="text-danger">{errors.hours}</p>)}
                        </Col>


                    </Row>

                </Row>


                {/* Image */}
                <Form.Group className='mt-5'>
                    <Form.Label className='mt-4' style={{ color: Colors.PRM_LIGHT_BLUE }}>Image </Form.Label>
                    <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />

                    <Row>
                        <Col>
                            {/* File Input */}
                            <Form.Label style={{ color: imageBorder }}>Image Input</Form.Label>
                            <Form.Control type="file" onChange={(e) => { handleImageSelect(e.target.files[0]) }} accept="image/*" style={{ borderColor: imageBorder }} />
                            {errors.image && (<p className="text-danger">{errors.image}</p>)}
                        </Col>
                        <Col>
                            <Flex>
                                <Form.Label style={{ color: imageBorder }}>Retailer Image</Form.Label>
                                {
                                    imageLoading == true ? <div style={{}}><CustomSpinner size={true} rowCenter={true} /></div>
                                        : imageStatus == 'succeeded' ? <div style={{ display: 'flex' }}><p style={{ color: 'green', fontWeight: '300' }}>Uploaded Successfully</p><AiOutlineCloudUpload size={32} color={'green'} style={{ paddingBottom: 12 }} /></div> : " "
                                }
                            </Flex>
                            <div style={{ height: 350 }} className="border">
                                {
                                    selectedImage == undefined ?
                                        <div style={{ textAlign: 'center' }}>
                                            <p style={{ color: 'white' }}>s</p>
                                            <p style={{ fontSize: 18, opacity: 0.4, fontWeight: '300', marginTop: 100 }}>Select the 'choose file' button below to add an image for the retailer</p>
                                        </div>
                                        :
                                        <img src={imagePreview} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 15 }} onLoad={() => { setImageLoading(false) }} />
                                }
                            </div>
                        </Col>
                    </Row>
                </Form.Group>

                <Col md={3} >
                    <Button variant={addingRetailerError ? "danger" : "primary"} onClick={handlePreSubmit} loading={false} style={{ width: 300 }} className="mt-2">
                        {addingRetailerStatus === 'loading' || imageStatus === "loading" ? <CustomSpinner size={'sm'} style={{ color: 'white' }} /> : 'Create Retailer Account'}
                    </Button>
                    {addingRetailerError && <p className="text-danger">{addingRetailerError}</p>}

                </Col>

            </Row>


            {/* Delivery Modal */}
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" show={showDeliveryModal} onHide={() => { setShowDeliveryModal(false) }}>
                <CountrySelector cancel={() => { setShowDeliveryModal(false) }} done={handleSelectCountries} />
            </Modal>

            <Modal show={showAirportModal} onHide={() => { setShowAirportModal(false) }} size="lg" aria-labelledby="contained-modal-title-vcenter" >
                <AirportListSelector cancel={() => { setShowAirportModal(false) }} done={handleSelectIataList} />
            </Modal>

            <Modal show={showHoursModel} onHide={() => { setShowHoursModel(false) }} size="lg" aria-labelledby="contained-modal-title-vcenter" >
                <HoursRangeSelector cancel={() => { setShowHoursModel(false) }} done={handleOpeningHours} />
            </Modal>
        </>
    )
}

export default RetailerForm;